// extracted by mini-css-extract-plugin
module.exports = {"paper-container":"PaperComponent_paper-container__2gNr5","paper-container--flexible":"PaperComponent_paper-container--flexible__35XIK"};